
import { makeStyles } from '@mui/styles';

const styles = (theme) => ({

    container: () => {
      return  {
          display: 'flex',
          height: '100vh',
          width: '100%',

          flexDirection: 'column !important',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          top: 0,
          left: 0,
          overflow: 'scroll',
      };
    },

    successContainer: () => {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },
  
    postSubscriptionBody: () => {
      return  {
        width: 'calc(100% - 64px)',
        flexDirection: 'column !important',
        justifyContent: 'center',
        alignItems: 'center',
      };
    },

    subtitle: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '20px',

        '& .MuiTypography-root': {
          fontFamily: 'GothamRounded',
          fontWeight: '300',
          textAlign: 'center',
         },
      };
    },

    bodyMessages: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '28px 0px',
        textAlign: 'center',

        '& .MuiTypography-root': {
          fontFamily: 'GothamRounded',
          fontWeight: '300',
        },
      };
    },

    shareButtonPanel: () => {
      return  {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: '60px',
      };
    },

    adSpace: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center',
      marginBottom: '64px',
    },

    adImage: ({ borderColor }) => {
      function getHoverBorder () {
        if (borderColor) {
          return `1px solid ${borderColor}`;
        }
        return `1px solid #15aae0`;
      }

      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '300px',
        height: '250px',
        border: '1px solid  #C7C8CA',
        cursor: 'pointer',
        borderRadius: '4px',
        overflow: 'hidden',
        '&:hover': {
          border: getHoverBorder(),
        }
      };
    },
 
    adUnitImage: {
      width: '300px',
      height: '250px',
    },

    recommendationBox: {
      display: 'flex',
      flexDirection: 'column !important',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      marginBottom: '64px',
    },

    recommendationMessage: {
      display: 'flex',
      justifyContent: 'center',
      width: '360px',
      fontWeight: 'bold',
      fontSize: '16px',
      marginBottom: '12px',
    },
 
    recommendationList: {
      display: 'flex',
      flexDirection: 'row',
      width: '300px',
      flexWrap: 'wrap',
    },

    thumbnailItem: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      width: '150px',
      height: '80px',
    },

    thumbnailSpace: ({ borderColor }) =>  {
      function getHoverBorder () {
        if (borderColor) {
          return `1px solid ${borderColor}`;
        }
        return `1px solid #c8d9f7`;
      }

      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '140px',
        height: '70px',
        border: '1px solid  #15aae0',
        cursor: 'pointer',
        borderRadius: '4px',
        '&:hover': {
          border: getHoverBorder(),
        }
      };
    },

    thumbnailImage: {
      display: 'block',
      width: '130px',
      height: '60px',
      objectFit: 'contain',
    },

  }
);

export default styles;
export const useStyles = makeStyles(styles);
